import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { CircularProgress } from "@mui/material";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  // Allow access if user is authenticated AND (is superuser OR has admin/editor role)
  const canAccessAdmin = user?.is_superuser || user?.profile?.role === "admin" || user?.profile?.role === "editor";
  
  if (!isAuthenticated || !canAccessAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;
